module.exports = __webpack_public_path__ + "static/media/pectoralis_major_left_weak.c05a0e86.png";